export default "__VITE_ASSET__41793619__"